export const NOTIF_TYPES = [
  { key: "streak_reminder", icon: "🔥", label: "Streak Reminder", desc: "Keep your streak alive today" },
  { key: "double_xp", icon: "⚡", label: "Double XP Alert", desc: "2× XP is active — log a workout" },
  { key: "comeback", icon: "💥", label: "Comeback Bonus", desc: "3× XP on next workout" },
  { key: "mission_reminder", icon: "🎯", label: "Mission Reminder", desc: "Daily missions still incomplete" },
  { key: "shield_awarded", icon: "🛡️", label: "Shield Awarded", desc: "A streak shield was added" },
  { key: "custom", icon: "📝", label: "Custom Message", desc: "Write your own notification" },
];
